export const THEME_CONFIG = {
    '0': {
        color: '0067ed'
    },
    '1': {
        color: '12b7f5'
    },
    '2': {
        color: 'ff9232'
    },
    '3': {
        color: 'ee685d'
    },
    '4': {
        color: '33cc99'
    }
};

export const CUSTOMER_COLOR_VALUE = -1;
